import { render, staticRenderFns } from "./tabDestinationCustomsData.vue?vue&type=template&id=06332a28&scoped=true&"
import script from "./tabDestinationCustomsData.vue?vue&type=script&lang=js&"
export * from "./tabDestinationCustomsData.vue?vue&type=script&lang=js&"
import style0 from "./tabDestinationCustomsData.vue?vue&type=style&index=0&id=06332a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06332a28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06332a28')) {
      api.createRecord('06332a28', component.options)
    } else {
      api.reload('06332a28', component.options)
    }
    module.hot.accept("./tabDestinationCustomsData.vue?vue&type=template&id=06332a28&scoped=true&", function () {
      api.rerender('06332a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabDestinationCustomsData.vue"
export default component.exports